import React, { useState } from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { CartType } from '@base/cart/useCart';
import BonusProdItem from '@base/cart/BonusProdItem';
import Iconfont from '@base/lib/Iconfont'
import { ProductDetailPopup } from '@app/common/ProductDetailPopup'
import { BONUS_ITEMS_DETAIL_HIDDEN_ELEMENTS } from '@base/cart/constant'
import { useTrans } from 'base/utils/i18n';

type IBonusItemListProps = {
    className?: string;
    cart: CartType;
    miniCartLinked?: boolean;
};

const BonusItemList: React.FC<IBonusItemListProps> = (props) => {
    const {
        cart: {
            bonusProdListData,
            onBonusProdSelect,
        } = {},
        miniCartLinked = false
    } = props;

    const [showAll, setShowAll] = useState<boolean>(false)
    const [detailVisible, setDetailVisible] = useState<boolean>(false);
    const [variantId, setVariantId] = useState<string>();
    const { t } = useTrans();

    const onQuickView = (variantId: string) => {
        setDetailVisible(true);
        setVariantId(variantId)
    }

    return (
        <>
            <ProductDetailPopup
                visible={detailVisible}
                onClose={() => setDetailVisible(false)}
                variantId={variantId}
                hiddenElements={BONUS_ITEMS_DETAIL_HIDDEN_ELEMENTS}
            />

            <div
                className={cn(
                    'bonus-products-wrap',
                    styles['bonus-products-wrap']
                )}
            >
                <p className="tips">{bonusProdListData?.tip}</p>

                {!!bonusProdListData?.items.length && (
                    <div>
                        <div>
                            {showAll ? (<>
                                {bonusProdListData?.items?.map((productItem) => {
                                    return (
                                        <BonusProdItem
                                            showType={'m'}
                                            onQuickView={onQuickView}
                                            key={productItem[0]?.variantId}
                                            miniCartLinked={miniCartLinked}
                                            bonusProduct={productItem}
                                            onBonusProdSelect={onBonusProdSelect}
                                        />
                                    )
                                })}
                            </>) : (
                                <BonusProdItem
                                    showType={'m'}
                                    onQuickView={onQuickView}
                                    miniCartLinked={miniCartLinked}
                                    bonusProduct={bonusProdListData?.items[0]}
                                    onBonusProdSelect={onBonusProdSelect}
                                />
                            )}
                        </div>

                        {bonusProdListData?.items?.length > 1 && (
                            <div
                                className={cn('view-all text-center')}
                                onClick={() => {
                                    setShowAll(!showAll)
                                }}
                            >
                                <span>{showAll ? t('web_common_btn_close') : t('web_common_view_all')}</span>&nbsp;
                                <Iconfont className={showAll ? 'icon-arrow-top' : 'icon-arrow-down'}/>
                            </div>
                        )}

                    </div>
                )}
            </div>
        </>

    );
};

export default BonusItemList